import DnStepper from 'src/components/Core/DnStepper'

const AuditTrailCard = ({ auditTrailLogs }) => {
  if (!auditTrailLogs) {
    return null
  }
  const stepperItems = auditTrailLogs.map((auditTrailLog) => ({
    id: auditTrailLog.auditTrailId,
    title: auditTrailLog.title,
    content: auditTrailLog.message,
  }))

  return (
    <div className="flex flex-col gap-6 rounded-lg border border-doubleNickel-gray-200 bg-doubleNickel-gray-50">
      <div className="flex flex-col gap-6 p-6">
        <div className="text-md font-semibold text-doubleNickel-gray-900">
          Audit Trail
        </div>
        <DnStepper
          items={stepperItems}
          emptyMessage="No audit trail found"
          dateFormat="hh:mm A MM/DD/YYYY"
        />
      </div>
    </div>
  )
}

export default AuditTrailCard
